import { ModuleV1Read, WorkflowV1Read } from '@ca/core/models';
import { createAction, props } from '@ngrx/store';

const systemModulesPrefix = '[System Modules]';
const segmentationWorkflowsPrefix = '[Segmentation Workflows]';
const trainingWorkflowsPrefix = '[Training Workflows]';

export const loadSystemModules = createAction(`${systemModulesPrefix} Load`);
export const loadSystemModulesSuccess = createAction(`${systemModulesPrefix} Loaded`, props<{ systemModules: ModuleV1Read[] }>());
export const loadSystemModulesFailed = createAction(`${systemModulesPrefix} Load failed`, props<{ error: unknown }>());

export const loadSegmentationWorkflows = createAction(`${segmentationWorkflowsPrefix} Load`);
export const loadSegmentationWorkflowsSuccess = createAction(`${segmentationWorkflowsPrefix} Loaded`, props<{ segmentationWorkflows: WorkflowV1Read[] }>());
export const loadSegmentationWorkflowsFailed = createAction(`${segmentationWorkflowsPrefix} Load failed`, props<{ error: unknown }>());

export const loadTrainingWorkflows = createAction(`${trainingWorkflowsPrefix} Load`);
export const loadTrainingWorkflowsSuccess = createAction(`${trainingWorkflowsPrefix} Loaded`, props<{ trainingWorkflows: WorkflowV1Read[] }>());
export const loadTrainingWorkflowsFailed = createAction(`${trainingWorkflowsPrefix} Load failed`, props<{ error: unknown }>());
